// extracted by mini-css-extract-plugin
export default {"filterHeader":"IdentifierFilterModal_filterHeader__YZRTG","root":"IdentifierFilterModal_root__WsTMN","container":"IdentifierFilterModal_container__w+bMd"};